import { render, staticRenderFns } from "./collect-customer-view.vue?vue&type=template&id=68689630&scoped=true&"
import script from "./collect-customer-view.vue?vue&type=script&lang=ts&"
export * from "./collect-customer-view.vue?vue&type=script&lang=ts&"
import style0 from "./collect-customer-view.vue?vue&type=style&index=0&id=68689630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68689630",
  null
  
)

export default component.exports